import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowJobConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const JobStack = createStackNavigator();

const JobNavigator = () => {
  return (
    <JobStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {nowJobConfig.map(({ Component, name }) => (
        <JobStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobStack.Navigator>
  );
};

export { JobNavigator };
